export default {"src":"/_next/static/media/broken-link-dark.ed18a3be.svg","height":100,"width":100};